
import { Component, Vue } from 'vue-property-decorator';
import DeviceLayout from '../../layouts/DeviceLayout.vue';
import PcPage from '../../blocks/PcPage.vue';
import MobilePage from '../../blocks/MobilePage.vue';
import { BAIDU_DOWNLOAD_URLS } from '../../config/downloadUrls';
import { LandingProps } from '../../config/types';

@Component({
  components: { DeviceLayout, PcPage, MobilePage },
})
export default class BaiduPage extends Vue {
  public landingProps: LandingProps = {
    downloadUrls: BAIDU_DOWNLOAD_URLS,
    hideList: false,
    showAppInfo: true,
    isBaiduDeveloper: false,
    showAddress: true,
  };
}
